import { Component, Input, OnInit } from '@angular/core';
import { SettingsModel } from '../../../models/settings.model';
import { SettingsService } from '../../../services/settings.service';
import { NexusComponent } from 'app/core/components/nexus/nexus.component';
import { NexusFormResultModel } from 'app/core/models/nexus-form-result.model';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-credit-reporting-settings',
    templateUrl: './credit-reporting-settings.component.html',
    styleUrls: ['./credit-reporting-settings.component.scss'],
    standalone: false
})
export class CreditReportingSettingsComponent extends NexusComponent implements OnInit {
  @Input() settings_model: SettingsModel;

  public previous_credit_reporting: boolean;
  public credit_reporting_result_model: NexusFormResultModel = new NexusFormResultModel();
  public is_form_valid = true;
  public credit_reporting_confirmation = false;
  public save_button_enabled = false;

  constructor(private settings_service: SettingsService) {
    super();
  }

  ngOnInit() {
    if (this.settings_model) {
      this.previous_credit_reporting = this.settings_model.credit_reporting.credit_reporting_enabled;
    }

    this.creditReportingEnabledCheck();
  }

  onModelChanged(model: any) {
    this.creditReportingEnabledCheck();
  }

  creditReportingCheck() {
    if(this.credit_reporting_confirmation == true)
    {
      this.save_button_enabled = false;
      this.credit_reporting_confirmation = false;
    }
    else if(this.credit_reporting_confirmation == false)
    {
      this.save_button_enabled = true;
      this.credit_reporting_confirmation = true;
    }
  }

  creditReportingEnabledCheck(){
    if(this.settings_model.credit_reporting.credit_reporting_enabled == false)
    {
      this.credit_reporting_confirmation = false;
      this.save_button_enabled = false;
    }
    else if(this.settings_model.credit_reporting.credit_reporting_enabled == true)
    {
      this.credit_reporting_confirmation = true;
      this.save_button_enabled = true;
    }
  }

  saveButtonCheck() {
    if(this.credit_reporting_confirmation == true && this.is_form_valid == true && this.save_button_enabled == true)
    {
      return false;
    }
    else
    {
      return true;
    }
  }

  onFormValid(valid: boolean) {
    this.is_form_valid = valid;
  }

  onSave() {
    this.credit_reporting_result_model.Reset();
    this.StartSpinner();

    this.settings_service.PutCreditReporting(this.settings_model.credit_reporting).subscribe(
      data => {
        this.settings_model = data;
        this.previous_credit_reporting = this.settings_model.credit_reporting.credit_reporting_enabled;
        this.StopSpinner();
      },
      err => {
        this.credit_reporting_result_model.Error(err);
        this.StopSpinner();
      });
  }
}
